// The production platform. Links fall back to it only when /config.js has not
// supplied a valid platform origin, which is how they behaved before the
// platform origin was read at runtime.
const PRODUCTION_PLATFORM_ORIGIN = 'https://app.mento.co';

// Treat runtime configuration as untrusted even when served by our own bootstrap.
export function memberPlatformLandingURL(value: unknown): string | null {
  if (
    typeof value !== 'string' ||
    !/^https?:\/\/[^/?#@%]+\/m$/.test(value) ||
    /[\\\s]/.test(value)
  ) {
    return null;
  }
  try {
    const url = new URL(value);
    if (
      !url.hostname ||
      url.username ||
      url.password ||
      url.pathname !== '/m' ||
      url.search ||
      url.hash ||
      /:\/m$/.test(value)
    ) {
      return null;
    }
    const validHost =
      url.hostname.startsWith('[') ||
      url.hostname.split('.').every((label) => /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(label));
    if (!validHost) {
      return null;
    }
    // URL normalizes IP literals, including IPv4-mapped IPv6, before this check.
    // Match Go's IP.IsLoopback: IPv4 127/8, IPv6 ::1 and mapped IPv4 127/8.
    const loopback =
      url.hostname === 'localhost' ||
      /^127(?:\.\d{1,3}){3}$/.test(url.hostname) ||
      url.hostname === '[::1]' ||
      /^\[::ffff:7f[0-9a-f]{2}:[0-9a-f]{1,4}\]$/.test(url.hostname);
    if (url.protocol !== 'https:' && !(url.protocol === 'http:' && loopback)) {
      return null;
    }
    return value;
  } catch {
    return null;
  }
}

/**
 * Build a link into the Mento platform for the environment this page runs in.
 *
 * The platform origin comes from MEMBER_PLATFORM_LANDING_URL in /config.js,
 * which the backend derives from calendar-description.platform-base-url
 * (https://dev.mento.co, https://staging.mento.co, https://app.mento.co).
 */
export function platformURL(path: string): string {
  const landing = memberPlatformLandingURL(
    typeof window !== 'undefined' ? window.__CONFIG__?.MEMBER_PLATFORM_LANDING_URL : undefined
  );
  const origin = landing ? new URL(landing).origin : PRODUCTION_PLATFORM_ORIGIN;
  return new URL(path, origin).toString();
}
